/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router-dom';
import withPieEncryption from '@vz-soe-utils/pieencryption';
import ContactInfo from '../../../../components/Web/ContactInfo/redesign';
import * as contactInfoActions from '../../actions';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import taggingSaga from '../../../Common/Tagging.js/sagas';
import saga from '../../sagas';
import contactInfo from '../../reducer';
import * as cartActions from '../../../../services/Cart/actions';
import cartSaga from '../../../../services/Cart/sagas';
import * as taggingActions from '../../../Common/Tagging.js/actions';
// import { getCreditHoldStatus } from '../../../../services/Cart/selectors/cartSelectors';
import { checkPlanReferenceData } from '../../../../utils/plansReference';
import { getAPPID } from '../../../../components/common/Helpers/index';
import * as paymentActions from '../../../PaymentInfo/actions';
import paymentInfo from '../../../PaymentInfo/sagas';
import * as creditCheckActions from '../../../CreditCheck/actions';
import creditCheckSaga from '../../../CreditCheck/sagas';

const mapStateToProps = (state, ownProps) => {
  // const contactInfoSelector = contactInfoSelectors.selectData(state);
  const contactBillingInfo = state.contactInfo ? state.contactInfo.contactBillingInfo : {};
  const editcontactInfo = state.contactInfo ? state.contactInfo.editContactInfo : {};
  const cartDetails = state.cartDetails || {};
  const setupType = cartDetails?.cartDetailsJson?.orderDetailsView?.installType?.indexOf('Prof') > -1 ? 'Prof' : 'Self';
  const orderDetails = cartDetails?.cartDetailsJson?.orderDetailsView || {};
  const isEmailSuccess = state.contactInfo ? state.contactInfo.emailAPiResponse : {};
  const validateOrder = state?.cartDetails?.validateOrder || {}; // getValidateOrder(state.cartDetails);
  const creditStatus = validateOrder?.orderDetails?.[0] || {};
  const isCreditHold = creditStatus && creditStatus.creditApprovalStatus && creditStatus.creditApprovalStatus !== 'AP'; // getCreditHoldStatus(state.cartDetails);
  const isCreditStatusAvailable =
    isCreditHold || validateOrder.downpaymentRequired || (validateOrder.errorMessage && validateOrder.errorMessage !== '');
  const plansReferenceData = checkPlanReferenceData(state.plansReferenceData);
  const billingFormValues = state.contactInfo && state.contactInfo.billingFormInfo ? state.contactInfo.billingFormInfo : {};
  const contactFormValues = state.contactInfo && state.contactInfo.contactFormInfo ? state.contactInfo.contactFormInfo : {};
  const securePinFormValues = state.contactInfo && state.contactInfo.securePinFormInfo ? state.contactInfo.securePinFormInfo : {};
  const marketDetails = state.contactInfo && state.contactInfo.marketDetails ? state.contactInfo.marketDetails : null;
  const isInvalidZipcodeError = state.contactInfo && state.contactInfo.isInvalidZipcodeError;
  const contactCtaValue = state.contactInfo && state.contactInfo.contactCtaValue ? state.contactInfo.contactCtaValue : 'error';
  const billingCtaValue = state.contactInfo && state.contactInfo.billingCtaValue ? state.contactInfo.billingCtaValue : 'error';
  const securePinCtaValue =
    state.contactInfo && state.contactInfo.securePinCtaValue && state.contactInfo.securePinCtaValue.pinError
      ? state.contactInfo.securePinCtaValue.pinError
      : false;
  const secureConfirmPinCtaValue =
    state.contactInfo && state.contactInfo.secureConfirmPinCtaValue && state.contactInfo.secureConfirmPinCtaValue.pinError
      ? state.contactInfo.secureConfirmPinCtaValue.pinError
      : false;
  const contactFnameCtaValue =
    state.contactInfo && state.contactInfo.contactFnameCtaValue && state.contactInfo.contactFnameCtaValue.contactFormError
      ? state.contactInfo.contactFnameCtaValue.contactFormError
      : false;
  const contactLnameCtaValue =
    state.contactInfo && state.contactInfo.contactLnameCtaValue && state.contactInfo.contactLnameCtaValue.contactFormError
      ? state.contactInfo.contactLnameCtaValue.contactFormError
      : false;
  const contactEmailCtaValue =
    state.contactInfo && state.contactInfo.contactEmailCtaValue && state.contactInfo.contactEmailCtaValue.contactFormError
      ? state.contactInfo.contactEmailCtaValue.contactFormError
      : false;
  const contactPhoneCtaValue =
    state.contactInfo && state.contactInfo.contactPhoneCtaValue && state.contactInfo.contactPhoneCtaValue.contactFormError
      ? state.contactInfo.contactPhoneCtaValue.contactFormError
      : false;
  const billingAddress1CtaValue =
    state.contactInfo && state.contactInfo.billingAddress1CtaValue && state.contactInfo.billingAddress1CtaValue.billingFormError
      ? state.contactInfo.billingAddress1CtaValue.billingFormError
      : false;
  const billingAddress2CtaValue =
    state.contactInfo && state.contactInfo.billingAddress2CtaValue && state.contactInfo.billingAddress2CtaValue.billingFormError
      ? state.contactInfo.billingAddress2CtaValue.billingFormError
      : false;
  const billingZipcodeCtaValue =
    state.contactInfo && state.contactInfo.billingZipcodeCtaValue && state.contactInfo.billingZipcodeCtaValue.billingFormError
      ? state.contactInfo.billingZipcodeCtaValue.billingFormError
      : false;
  const billingInfoEdited = state.contactInfo && state.contactInfo.billingInfoEdited ? state.contactInfo.billingInfoEdited : false;
  const cartSelector = state.cartDetails ? state.cartDetails.cartDetailsJson : {};
  const contactInfoSelector = cartSelector && cartSelector.primaryUserInfo ? cartSelector.primaryUserInfo : {};
  const contactInfoNSESelector = cartSelector && cartSelector.cart5GAddress ? cartSelector.cart5GAddress : {};
  const apiResponse =
    state.contactInfo && state.contactInfo.response && state.contactInfo.response && state.contactInfo.response.serviceHeader
      ? state.contactInfo.response.serviceHeader
      : null;
  const currentView = state.currentView || {};
  const isUpdateInfoSuccess = state.contactInfo?.isUpdateInfoSuccess;
  const contactContinueCtaValue = state.contactInfo && state.contactInfo.contactContinueCtaValue ? state.contactInfo.contactContinueCtaValue : false;
  // const isUpdateIspuInfoFlag = state.contactInfo?.isUpdateIspuInfoFlag;
  const billingAddressError = state.contactInfo?.billingAddressError;
  const isLoggedIn = getAPPID() === 'AAL';
  const contactInfoEditError = state.contactInfo ? state.contactInfo.contactInfoEditError : {};
  const contactFormInfoEnableBtn = !!contactInfoEditError;
  const paymentInfoState = state && state.paymentInfo;
  const paymentOptions = state && state.paymentInfo && state.paymentInfo.data && state.paymentInfo.data.paymentOptions;
  const isBTAAvailable = paymentOptions && paymentOptions.filter((item) => item.paymentType === 'AC');
  let otherPaymentOptions = [];
  let savedcardOption =
    paymentOptions && paymentOptions.filter((item) => item.paymentType === 'CR' && item.savedCCList && item.savedCCList.length !== 0);
  savedcardOption = savedcardOption && savedcardOption.map((obj) => ({ ...obj, paymentType: 'SC' }));
  otherPaymentOptions = paymentOptions && paymentOptions.concat(savedcardOption);
  const isBTAEligible = state && state.shippingInfo && state.shippingInfo.isBTAEligible;
  const shippingInfoState = state.shippingInfo;
  const updatePersonalError = state.contactInfo?.showContactPageError;
  const serviceinfo = state?.contactInfo?.serviceinfo;
  const ShippingInfoDetails = state.shippingInfo?.ShippingInfoDetails;
  const creditStatusLanded = state.creditStatus?.creditStatusLanded;
  const shippingState = state.termsAndConditions || {};
  const securePinDataDeviceSucess = state?.contactInfo?.securePinDataDeviceSucess || {};
  const billingContactInfo = state.contactInfo?.billingFormInfo || {};
  if (securePinDataDeviceSucess) {
    shippingState.securePinDataDeviceSucess = securePinDataDeviceSucess;
  }
  const securePinData = state?.contactInfo?.securePinData || {};
  if (securePinData) {
    shippingState.securePinData = securePinData;
  }
  const commonData = state?.contactInfo?.commonData || {};
  if (commonData) {
    shippingState.commonData = commonData;
  }
  const contactInvalidCaseError = state.contactInfo?.contactInvalidCaseError;
  const contactInfoError = state.contactInfo?.contactInfoError || false;
  const contactInfoNtfyMsg = state.contactInfo?.contactInfoNtfyMsg || null;
  const eidQuestionsFromCreditStatus = state.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.eidQuestionnaire;
  const isEmailExists =
    state.contactInfo?.emailAPiResponse?.amValidationResponse?.emailAddressAsUserId === 'true' ||
    ((state.contactInfo?.emailAPiResponse?.valid === 'Valid' || state.contactInfo?.emailAPiResponse?.valid === 'White_listed') &&
      !state.contactInfo?.emailAPiResponse?.amValidationResponse);
  const { universalProfileCreationBannerMessages } = ownProps;
  const passwordValidationFailed = state.contactInfo?.passwordValidationFailed;
  const apiLoaded = state.SessionValues?.apiLoaded;
  const {
    emailMaxAttempts,
    password,
    isPasswordRulesCheckboxChecked,
    previousEmail,
    isUniversalProfileCreated,
    universalProfileCreationStatus,
    isCradleSuccess,
    isSeqUPICompleted,
    isConInfoEdited,
    latestSuccessfullyVerifiedEmail,
  } = state.contactInfo;
  const creditReviewSuccessResponse = state.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo;
  const enableCheckbox = state?.contactInfo?.splFlag;

  return {
    // contactInfoSelector: contactInfoSelector,
    billingInfoNSE: contactInfoNSESelector,
    billingInfoAAL: contactInfoSelector,
    contactContinueCtaValue,
    contactBillingInfo,
    editcontactInfo,
    cartDetails,
    setupType,
    currentView,
    orderDetails,
    plansReferenceData,
    isCreditStatusAvailable,
    billingFormValues,
    contactFormValues,
    securePinFormValues,
    marketDetails,
    isInvalidZipcodeError,
    billingInfoEdited,
    contactCtaValue,
    billingCtaValue,
    securePinCtaValue,
    secureConfirmPinCtaValue,
    contactFnameCtaValue,
    contactLnameCtaValue,
    contactEmailCtaValue,
    contactPhoneCtaValue,
    billingAddress1CtaValue,
    billingAddress2CtaValue,
    billingZipcodeCtaValue,
    apiResponse,
    isUpdateInfoSuccess,
    billingAddressError,
    isLoggedIn,
    contactInfoEditError,
    isEmailSuccess,
    contactFormInfoEnableBtn,
    cartSelector,
    paymentInfoState,
    isBTAAvailable,
    isBTAEligible,
    otherPaymentOptions,
    shippingInfoState,
    updatePersonalError,
    serviceinfo,
    ShippingInfoDetails,
    creditStatusLanded,
    eidQuestionsFromCreditStatus,
    contactInvalidCaseError,
    emailMaxAttempts,
    billingContactInfo,
    // isUpdateIspuInfoFlag,
    contactInfoError,
    contactInfoNtfyMsg,
    isUniversalProfileCreated,
    password: password || '',
    passwordValidationFailed,
    isEmailExists,
    universalProfileCreationStatus,
    universalProfileCreationBannerMessages,
    isPasswordRulesCheckboxChecked,
    previousEmail,
    isCradleSuccess,
    apiLoaded,
    creditReviewSuccessResponse,
    isSeqUPICompleted,
    enableCheckbox,
    isConInfoEdited,
    latestSuccessfullyVerifiedEmail,
    unitlist: state?.cartDetails?.availableAddressUnit2 ? state?.cartDetails?.availableAddressUnit2?.data : [],
    appConfigValue: state?.cartDetails?.appConfig ? state?.cartDetails?.appConfig : [],
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...contactInfoActions,
      ...cartActions,
      ...taggingActions,
      ...paymentActions,
      ...creditCheckActions,
    },
    dispatch,
  );
}
const withReducer = compose(
  injectReducer({ key: 'contactInfo', reducer: contactInfo }),
  injectSaga({ key: 'paymentInfo', saga: paymentInfo }),
);
const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);
const withSaga = compose(
  injectSaga({ key: 'contactInfo', saga }),
  injectSaga({ key: 'cartDetails', saga: cartSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
  injectSaga({ key: 'creditCheck', saga: creditCheckSaga }),
);

export default withRouter(
  compose(
    withSaga,
    withReducer,
    withConnect,
  )(withPieEncryption(ContactInfo, window.vzFlags && window.vzFlags.isProd ? 'PRODUCTION' : 'UAT')),
);
